export default "__VITE_ASSET__D65Sxrb8__"